import { MusePeer } from '@/services/RoomContextMusePeer'
import { cn } from '@/utlis/cn'
import DesktopIcon from '@/CustomIcons/DesktopIcon'
import { Username } from '@/components/Username'

type UsernameOverlayProps = {
    peer: 'me' | MusePeer
    size?: 'small' | 'regular'
    kind?: 'camera' | 'screen'
}

export function UsernameOverlay({ peer, size = 'regular', kind = 'camera' }: UsernameOverlayProps) {
    const position = 'absolute flex items-center justify-center z-10 min-w-[80px] gap-1'
    const bg =
        'border-muse-toplit-low bg-white/3 rounded-[32px] shadow-glow bg-blend-luminosity group-hover:bg-black/20 group-hover:backdrop-blur-[8px]'
    const font = 'font-medium opacity-80 group-hover:opacity-100 text-shadow-[0_0_3px_rgba(0,0,0,0.75)]'

    const sizeStyles =
        size === 'small' ? 'top-1 left-1 px-[10px] py-[7px]' : 'top-[16px] left-[16px] px-[10px] py-[7px]'

    return (
        <div className={cn(position, bg, sizeStyles, font)}>
            {kind === 'screen' && <DesktopIcon style={{ fontSize: '1.3rem' }} />}
            <Username isMe={peer === 'me'} peer={peer !== 'me' ? peer : undefined} suffix />
        </div>
    )
}
